import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'

import CloseIcon from '@mui/icons-material/Close'

const headerSx = {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center'
}

export class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    actions: PropTypes.node
  }

  onClose = () => {
    this.props.hideModal()
  }

  render() {
    const { children, fullScreen, title, actions } = this.props

    return (
      <Dialog
        open
        fullScreen={fullScreen}
        onClose={this.onClose}
      >
        <div style={{ display: 'flex', flexFlow: 'row nowrap', alignItems: 'center' }}>
          <DialogTitle sx={headerSx}>{title}</DialogTitle>

          {fullScreen && (
            <IconButton
              sx={{ ml: 'auto', alignSelf: 'center', mr: 1 }}
              onClick={this.onClose}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <DialogContent sx={{ minWidth: '550px', width: 'auto' }}>{children}</DialogContent>
        {actions && <DialogActions>{actions}</DialogActions>}
      </Dialog>
    )
  }
}

// v5 removed withMobileDialog; replicate "fullScreen on small screens" with
// the useMediaQuery hook. The inner Modal class still takes fullScreen as a
// prop so it stays simple to test in isolation.
const ResponsiveModal = props => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Modal
      {...props}
      fullScreen={fullScreen}
    />
  )
}

export default ResponsiveModal
